// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__24j1p","rotating":"Grid_rotating__30rou"};